<style>
    .con-vs-popup .vs-popup {
        width: 1000px;
    }
</style>

<template>
    <div class="vx-col w-full mb-base">
        <vs-card class="p-4 mb-6">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Movement Order Detail</h4>
                </div>
                <!-- <vs-button
                    @click="savemovementorder"
                    class="btn mb-4 md:mb-0 mr-4"
                    icon="add"
                    :disabled="this.draftmovementorder.rowdata.length < 1 ? true : false"
                >Save</vs-button> -->
                <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="savemovementorder" icon="save" :disabled="draftmovementorder.rowdata.length < 1 ? true : false">Save</vs-button>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Reference*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="movementorder.reference" />
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Movement Date*
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="movementorder.movement_date" />
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Client ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="movementorder.client_id"
                                width="100%"
                                autocomplete
                                @input-change="searchDropdown($event, client)"
                            >
                                <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Warehouse ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="movementorder.warehouse_id"
                                width="100%"
                                autocomplete
                                @input-change="searchDropdown($event, warehouse)"
                            >
                                <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Auto Confirm
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-checkbox v-model="movementorder.auto_confirm"></vs-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </vs-card>
        <vs-card class="p-4 mb-6">
            <vs-row class="w-full flex justify-end">
                <vs-button @click="handleShowAddForm" :disabled="!movementorder.client_id || !movementorder.warehouse_id" class="btn mb-4 md:mb-0 mr-4" icon="add">Add</vs-button>
                <vs-button @click="handleDeleteForm" class="btn mb-4 md:mb-0" icon="remove">Remove</vs-button>
            </vs-row>
            <div style="max-height: 400px; overflow-x: auto" class="mt-5">
                <vs-table multiple v-model="selected" :data="draftmovementorder.rowdata" hoverFlat>
                    <template slot="thead">
                        <vs-th>Line ID</vs-th>
                        <vs-th>Product ID</vs-th>
                        <vs-th>Description</vs-th>
                        <vs-th>Pack ID</vs-th>
                        <vs-th>Batch</vs-th>
                        <vs-th>Exp. Date</vs-th>
                        <vs-th>Base Qty</vs-th>
                        <vs-th>Base UoM</vs-th>
                        <vs-th>Stock Type</vs-th>
                        <vs-th>Src. Loc. Type</vs-th>
                        <vs-th>Src. Loc. ID</vs-th>
                        <vs-th>Src. Loc. Storage</vs-th>
                        <vs-th>Dest. Loc. Type</vs-th>
                        <vs-th>Dest. Loc. ID</vs-th>
                        <vs-th>Dest. Loc. Storage</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="detail" :key="index" v-for="(detail, index) in data" >
                            <vs-td>{{ detail.line_id }}</vs-td>
                            <vs-td>{{ detail.product_code }}</vs-td>
                            <vs-td>{{ detail.description_1 }}</vs-td>
                            <vs-td>{{ detail.pack_id }}</vs-td>
                            <vs-td>{{ detail.batch }}</vs-td>
                            <vs-td>{{ detail.expired_date }}</vs-td>
                            <vs-td>{{ detail.base_qty }}</vs-td>
                            <vs-td>{{ detail.base_uom_name }}</vs-td>
                            <vs-td>{{ detail.stock_type_name }}</vs-td>
                            <vs-td>{{ detail.location_type_code }}</vs-td>
                            <vs-td>{{ detail.location_code }}</vs-td>
                            <vs-td>{{ detail.storage_unit }}</vs-td>
                            <vs-td>{{ detail.destination_location_type }}</vs-td>
                            <vs-td>{{ detail.destination_location }}</vs-td>
                            <vs-td>{{ detail.destination_storage_unit }}</vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </vs-card>

        <vs-popup
            title="Items Detail"
            :active.sync="showdraftpopup"
            style="z-index: 99998"
        >
            <div class="con-exemple-prompt">
                <vs-tabs alignment="center">
                    <vs-tab label="Single Item">
                        <div class="vx-row mt-6">
                            <div class="vx-col lg:w-1/2 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Product Code
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-select
                                            class="selectExample"
                                            v-model="singlemovementdata.product_id"
                                            width="100%"
                                            autocomplete
                                        >
                                            <vs-select-item v-for="(item, index) in product" :key="index" :value="item.id" :text="item.product_code"/>
                                        </vs-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Description
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input disabled class="w-full" v-model="singlemovementdata.description" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Pack ID
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="singlemovementdata.pack_id" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Batch
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="singlemovementdata.batch" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Expired Date
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <flat-pickr class="w-full" v-model="singlemovementdata.exp_date" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Src. Location Code
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vx-input-group class="mb-base">
                                            <vs-input v-model="singlemovementdata.source_location_code"/>

                                            <template slot="append">
                                                <div class="append-text btn-addon">
                                                    <vs-button
                                                        color="primary"
                                                        @click="getSingleSourceLocationData"
                                                        :disabled="!singlemovementdata.product_id"
                                                    >Search</vs-button>
                                                </div>
                                            </template>
                                        </vx-input-group>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/2 w-full">
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Qty
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <div class="vx-row">
                                            <div class="vx-col w-1/2">
                                                <vs-input class="w-full" v-model="singlemovementdata.available_qty" />
                                            </div>
                                            <div class="vx-col w-1/2">
                                                <vx-input-group>
                                                    <vs-input
                                                        v-model="singlemovementdata.available_uom"
                                                    />

                                                    <template slot="append">
                                                        <div class="append-text btn-addon">
                                                            <vs-button
                                                                size="small"
                                                                color="primary"
                                                                type="border"
                                                                icon-pack="feather"
                                                                icon="icon-search"
                                                                @click="handlepopupuom"
                                                            ></vs-button>
                                                        </div>
                                                    </template>
                                                </vx-input-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Base Qty
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <div class="vx-row">
                                            <div class="vx-col w-1/2">
                                                <vs-input class="w-full" v-model="singlemovementdata.base_qty" />
                                            </div>
                                            <div class="vx-col w-1/2">
                                                <vs-input
                                                    class="w-full"
                                                    v-model="singlemovementdata.base_uom"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Stock Type
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-select
                                            class="selectExample"
                                            v-model="singlemovementdata.stock_type"
                                            width="100%"
                                            autocomplete
                                            @input-change="searchDropdown($event, stock_type)"
                                        >
                                            <vs-select-item v-for="(item, index) in stock_type.data" :key="index" :value="item.id" :text="item.name"/>
                                        </vs-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Dest. Location
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vx-input-group class="mb-base">
                                            <vs-input v-model="singlemovementdata.dest_location_code"/>

                                            <template slot="append">
                                                <div class="append-text btn-addon">
                                                    <vs-button
                                                        color="primary"
                                                        @click="handlepopupsingledestinationlocation"
                                                        :disabled="!singlemovementdata.product_id"
                                                    >Search</vs-button>
                                                </div>
                                            </template>
                                        </vx-input-group>
                                    </div>
                                </div>
                            </div>
                            <vs-row class="flex justify-end">
                                <vs-button
                                    @click="savesinglemovementdraft"
                                    class="mr-4"
                                    color="primary"
                                    type="filled"
                                >Next</vs-button>
                                <vs-button @click="showdraftpopup = false" type="flat">Cancel</vs-button>
                            </vs-row>
                        </div>
                    </vs-tab>
                    <vs-tab label="Multi Items by Location">
                        <div class="vx-row mt-6">
                            <div class="vx-col lg:w-1/2 w-full">
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col sm:w-1/3 w-full">
                                        <span>Src. Location</span>
                                    </div>
                                    <div class="vx-col sm:w-2/3 w-full">
                                        <vx-input-group>
                                            <vs-input
                                                v-model="multimovementdata.source_location_code"
                                            />
                                            <template slot="append">
                                                <div class="append-text btn-addon">
                                                    <vs-button
                                                        color="primary"
                                                        @click="handlepopupmultisourcelocation"
                                                    >Search</vs-button>
                                                </div>
                                            </template>
                                        </vx-input-group>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col sm:w-1/3 w-full">
                                        <span>Dest. Location</span>
                                    </div>
                                    <div class="vx-col sm:w-2/3 w-full">
                                        <vx-input-group>
                                            <vs-input
                                                v-model="multimovementdata.dest_location_code"
                                            />

                                            <template slot="append">
                                                <div class="append-text btn-addon">
                                                    <vs-button
                                                        color="primary"
                                                        @click="handlepopupmultidestinationlocation"
                                                    >Search</vs-button>
                                                </div>
                                            </template>
                                        </vx-input-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <vs-row class="flex justify-end">
                            <vs-button
                                @click="savemultimovementdraft"
                                class="mr-4"
                                color="primary"
                                type="filled"
                            >Next</vs-button>
                            <vs-button @click="showdraftpopup = false" type="flat">Cancel</vs-button>
                        </vs-row>
                    </vs-tab>
                </vs-tabs>
            </div>
        </vs-popup>

        <vs-popup title="Product" :active.sync="products.show" style="z-index: 99999">
            <vx-input-group>
                <vs-input v-model="products.search" placeholder="Product" />
                <template slot="append">
                    <div class="append-text btn-addon">
                        <vs-button
                            size="small"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-search"
                            @click="handleproductsearch"
                        ></vs-button>
                    </div>
                </template>
            </vx-input-group>
            <ag-grid-vue
                :gridOptions="products.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="products.columnDefs"
                :defaultColDef="products.defaultColDef"
                :rowData="products.rowdata"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @rowDoubleClicked="rowdoubleclickproduct"
                @selection-changed="onchangeselectionproduct"
            ></ag-grid-vue>
        </vs-popup>

        <vs-popup
            title="Source Location"
            :active.sync="singlesourcelocations.show"
            style="z-index: 99999"
        >
            <vx-input-group>
                <vs-input v-model="singlesourcelocations.search" placeholder="Source Location" />
                <template slot="append">
                    <div class="append-text btn-addon">
                        <vs-button
                            type="border"
                            @click="handlesinglesourcelocationsearch"
                        >Search</vs-button>
                    </div>
                </template>
            </vx-input-group>
            <ag-grid-vue
                :gridOptions="singlesourcelocations.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="singlesourcelocations.columnDefs"
                :defaultColDef="singlesourcelocations.defaultColDef"
                :rowData="singlesourcelocations.rowdata"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @rowDoubleClicked="rowdoubleclicksinglesourcelocation"
                @selection-changed="onchangeselectionsinglesourcelocation"
            ></ag-grid-vue>
        </vs-popup>

        <vs-popup title="Uoms" :active.sync="uoms.show" style="z-index: 99999">
            <vx-input-group>
                <vs-input v-model="uoms.search" placeholder="Source Location" />
                <template slot="append">
                    <div class="append-text btn-addon">
                        <vs-button
                            size="small"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-search"
                            @click="handleuomsearch"
                        ></vs-button>
                    </div>
                </template>
            </vx-input-group>
            <ag-grid-vue
                :gridOptions="uoms.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="uoms.columnDefs"
                :defaultColDef="uoms.defaultColDef"
                :rowData="uoms.rowdata"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @rowDoubleClicked="rowdoubleclickuom"
                @selection-changed="onchangeselectionuom"
            ></ag-grid-vue>
        </vs-popup>

        <vs-popup
            title="Destination Location"
            :active.sync="singledestinationlocations.show"
            style="z-index: 99999"
        >
            <vx-input-group>
                <vs-input
                    v-model="singledestinationlocations.search"
                    placeholder="Destination Location"
                />
                <template slot="append">
                    <div class="append-text btn-addon">
                        <vs-button
                            color="primary"
                            @click="handlesingledestinationlocationsearch"
                        >Search</vs-button>
                    </div>
                </template>
            </vx-input-group>
            <ag-grid-vue
                :gridOptions="singledestinationlocations.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="singledestinationlocations.columnDefs"
                :defaultColDef="singledestinationlocations.defaultColDef"
                :rowData="singledestinationlocations.rowdata"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @rowDoubleClicked="rowdoubleclicksingledestinationlocation"
                @selection-changed="onchangeselectionsingledestinationlocation"
            ></ag-grid-vue>
        </vs-popup>

        <vs-popup
            title="Source Location"
            :active.sync="multisourcelocations.show"
            style="z-index: 99999"
        >
            <vx-input-group>
                <vs-input v-model="multisourcelocations.search" placeholder="Source Location" />
                <template slot="append">
                    <div class="append-text btn-addon">
                        <vs-button
                            size="small"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-search"
                            @click="handlemultisourcelocationsearch"
                        ></vs-button>
                    </div>
                </template>
            </vx-input-group>
            <ag-grid-vue
                :gridOptions="multisourcelocations.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="multisourcelocations.columnDefs"
                :defaultColDef="multisourcelocations.defaultColDef"
                :rowData="multisourcelocations.rowdata"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @rowDoubleClicked="rowdoubleclickmultisourcelocation"
                @selection-changed="onchangeselectionmultisourcelocation"
            ></ag-grid-vue>
        </vs-popup>

        <vs-popup
            title="Destination Location"
            :active.sync="multidestinationlocations.show"
            style="z-index: 99999"
        >
            <vx-input-group>
                <vs-input
                    v-model="multidestinationlocations.search"
                    placeholder="Destination Location"
                />
                <template slot="append">
                    <div class="append-text btn-addon">
                        <vs-button
                            size="small"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-search"
                            @click="handlemultidestinationlocationsearch"
                        ></vs-button>
                    </div>
                </template>
            </vx-input-group>
            <ag-grid-vue
                :gridOptions="multidestinationlocations.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="multidestinationlocations.columnDefs"
                :defaultColDef="multidestinationlocations.defaultColDef"
                :rowData="multidestinationlocations.rowdata"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @rowDoubleClicked="rowdoubleclickmultidestinationlocation"
                @selection-changed="onchangeselectionmultidestinationlocation"
            ></ag-grid-vue>
        </vs-popup>
    </div>
    <!-- <div>
        <vs-card class="p-4 mb-6">
            <vs-row class="w-full flex justify-end">
                <vs-button @click="handleShowAddForm" class="btn mb-4 md:mb-0 mr-4" icon="add">Add</vs-button>
                <vs-button @click="handleDeleteForm" class="btn mb-4 md:mb-0" icon="remove">Remove</vs-button>
            </vs-row>
            <ag-grid-vue
                :gridOptions="draftmovementorder.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="draftmovementorder.columnDefs"
                :defaultColDef="draftmovementorder.defaultColDef"
                :rowData="draftmovementorder.rowdata"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="multiple"
                @selection-changed="onchangeselectionproduct"
            ></ag-grid-vue>
        </vs-card>

        <vs-popup
            title="Items Detail"
            :active.sync="showdraftpopup"
            fullscreen
            style="z-index: 99998"
        >
            <div class="con-exemple-prompt">
                <vs-tabs alignment="center">
                    <vs-tab label="Single Item">
                        <vs-row>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                                <vs-row>
                                    <div class="vx-row mb-6 w-full">
                                        <div class="vx-col sm:w-1/3 w-full">
                                            <span>Product Code</span>
                                        </div>
                                        <div class="vx-col sm:w-2/3 w-full">
                                            <vx-input-group>
                                                <vs-input
                                                    v-model="singlemovementdata.product_code"
                                                    placeholder="Product"
                                                />

                                                <template slot="append">
                                                    <div class="append-text btn-addon">
                                                        <vs-button
                                                            size="small"
                                                            color="primary"
                                                            type="border"
                                                            icon-pack="feather"
                                                            icon="icon-search"
                                                            @click="handlepopupproduct"
                                                        ></vs-button>
                                                    </div>
                                                </template>
                                            </vx-input-group>
                                        </div>
                                    </div>
                                    <div class="vx-row mb-6 w-full">
                                        <div class="vx-col sm:w-1/3 w-full">
                                            <span>Description</span>
                                        </div>
                                        <div class="vx-col sm:w-2/3 w-full">
                                            <vs-input
                                                disabled
                                                class="w-full"
                                                v-model="singlemovementdata.description"
                                                placeholder="Description"
                                            />
                                        </div>
                                    </div>
                                    <div class="vx-row mb-6 w-full">
                                        <div class="vx-col sm:w-1/3 w-full">
                                            <span>Pack ID</span>
                                        </div>
                                        <div class="vx-col sm:w-2/3 w-full">
                                            <vs-input
                                                class="w-full"
                                                v-model="singlemovementdata.pack_id"
                                                placeholder="Pack ID"
                                            />
                                        </div>
                                    </div>
                                    <div class="vx-row mb-6 w-full">
                                        <div class="vx-col sm:w-1/3 w-full">
                                            <span>Batch</span>
                                        </div>
                                        <div class="vx-col sm:w-2/3 w-full">
                                            <vs-input
                                                class="w-full"
                                                v-model="singlemovementdata.batch"
                                                placeholder="Batch"
                                            />
                                        </div>
                                    </div>
                                    <div class="vx-row mb-6 w-full">
                                        <div class="vx-col sm:w-1/3 w-full">
                                            <span>Expire Date</span>
                                        </div>
                                        <div class="vx-col sm:w-2/3 w-full">
                                            <flat-pickr
                                                class="w-full"
                                                v-model="singlemovementdata.exp_date"
                                                placeholder="Exp Date"
                                            />
                                        </div>
                                    </div>
                                    <div class="vx-row mb-6 w-full">
                                        <div class="vx-col sm:w-1/3 w-full">
                                            <span>Source Location Code</span>
                                        </div>
                                        <div class="vx-col sm:w-2/3 w-full">
                                            <vx-input-group>
                                                <vs-input
                                                    v-model="singlemovementdata.source_location_code"
                                                    placeholder="Source Location ID"
                                                />
                                                <template slot="append">
                                                    <div class="append-text btn-addon">
                                                        <vs-button
                                                            size="small"
                                                            color="primary"
                                                            type="border"
                                                            icon-pack="feather"
                                                            icon="icon-search"
                                                            @click="handlepopupsinglesourcelocation"
                                                        ></vs-button>
                                                    </div>
                                                </template>
                                            </vx-input-group>
                                        </div>
                                    </div>
                                    <div class="vx-row mb-6 w-full">
                                        <div class="vx-col sm:w-1/3 w-full">
                                            <span>Source Storage Unit</span>
                                        </div>
                                        <div class="vx-col sm:w-2/3 w-full">
                                            <vs-input
                                                class="w-full"
                                                v-model="singlemovementdata.source_storage_unit"
                                                placeholder="Source Storage Unit"
                                            />
                                        </div>
                                    </div>
                                </vs-row>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6">
                                <vs-row>
                                    <div class="vx-row mb-6 w-full">
                                        <div class="vx-col sm:w-1/3 w-full">
                                            <span>Quantity</span>
                                        </div>
                                        <div class="vx-col sm:w-1/3 w-full">
                                            <vs-input
                                                class="w-full"
                                                v-model="singlemovementdata.available_qty"
                                                placeholder="Available Quantity"
                                            />
                                        </div>
                                        <div class="vx-col sm:w-1/3 w-full">
                                            <vx-input-group>
                                                <vs-input
                                                    v-model="singlemovementdata.available_uom"
                                                    placeholder="Available UoM"
                                                />

                                                <template slot="append">
                                                    <div class="append-text btn-addon">
                                                        <vs-button
                                                            size="small"
                                                            color="primary"
                                                            type="border"
                                                            icon-pack="feather"
                                                            icon="icon-search"
                                                            @click="handlepopupuom"
                                                        ></vs-button>
                                                    </div>
                                                </template>
                                            </vx-input-group>
                                        </div>
                                    </div>
                                    <div class="vx-row mb-6 w-full">
                                        <div class="vx-col sm:w-1/3 w-full">
                                            <span>Base Qty</span>
                                        </div>
                                        <div class="vx-col sm:w-1/3 w-full">
                                            <vs-input
                                                class="w-full"
                                                v-model="singlemovementdata.base_qty"
                                                placeholder="Base Quantity"
                                                disabled
                                            />
                                        </div>
                                        <div class="vx-col sm:w-1/3 w-full">
                                            <vs-input
                                                class="w-full"
                                                v-model="singlemovementdata.base_uom"
                                                placeholder="Base UoM"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div class="vx-row mb-6 w-full">
                                        <div class="vx-col sm:w-1/3 w-full">
                                            <span>Stock Type</span>
                                        </div>
                                        <div class="vx-col sm:w-2/3 w-full">
                                            <vx-input-group>
                                                <vs-input
                                                    v-model="singlemovementdata.stock_type"
                                                    placeholder="Stock Type"
                                                />

                                                <template slot="append">
                                                    <div class="append-text btn-addon">
                                                        <vs-button
                                                            size="small"
                                                            color="primary"
                                                            type="border"
                                                            icon-pack="feather"
                                                            icon="icon-search"
                                                        ></vs-button>
                                                    </div>
                                                </template>
                                            </vx-input-group>
                                        </div>
                                    </div>
                                    <div class="vx-row mb-6 w-full">
                                        <div class="vx-col sm:w-1/3 w-full">
                                            <span>Dest. Location ID</span>
                                        </div>
                                        <div class="vx-col sm:w-2/3 w-full">
                                            <vx-input-group>
                                                <vs-input
                                                    v-model="singlemovementdata.dest_location_code"
                                                    placeholder="Dest Location ID"
                                                />

                                                <template slot="append">
                                                    <div class="append-text btn-addon">
                                                        <vs-button
                                                            size="small"
                                                            color="primary"
                                                            type="border"
                                                            icon-pack="feather"
                                                            icon="icon-search"
                                                            @click="handlepopupsingledestinationlocation"
                                                        ></vs-button>
                                                    </div>
                                                </template>
                                            </vx-input-group>
                                        </div>
                                    </div>
                                    <div class="vx-row mb-6 w-full">
                                        <div class="vx-col sm:w-1/3 w-full">
                                            <span>Dest. Storage Unit</span>
                                        </div>
                                        <div class="vx-col sm:w-2/3 w-full">
                                            <vs-input
                                                class="w-full"
                                                v-model="singlemovementdata.dest_storage_unit"
                                                placeholder="Dest Storage Unit"
                                            />
                                        </div>
                                    </div>
                                </vs-row>
                            </vs-col>
                        </vs-row>
                        <vs-row class="flex justify-end">
                            <vs-button
                                @click="savesinglemovementdraft"
                                class="mr-4"
                                color="primary"
                                type="filled"
                            >Next</vs-button>
                            <vs-button @click="showdraftpopup = false" type="flat">Cancel</vs-button>
                        </vs-row>
                    </vs-tab>
                    <vs-tab label="Multi Items by Location">
                        <vs-row>
                            <div class="vx-row mb-6 w-full">
                                <div class="vx-col sm:w-1/3 w-full">
                                    <span>Source Location Code</span>
                                </div>
                                <div class="vx-col sm:w-2/3 w-full">
                                    <vx-input-group>
                                        <vs-input
                                            v-model="multimovementdata.source_location_code"
                                            placeholder="Source Location ID"
                                        />
                                        <template slot="append">
                                            <div class="append-text btn-addon">
                                                <vs-button
                                                    size="small"
                                                    color="primary"
                                                    type="border"
                                                    icon-pack="feather"
                                                    icon="icon-search"
                                                    @click="handlepopupmultisourcelocation"
                                                ></vs-button>
                                            </div>
                                        </template>
                                    </vx-input-group>
                                </div>
                            </div>
                            <div class="vx-row mb-6 w-full">
                                <div class="vx-col sm:w-1/3 w-full">
                                    <span>Dest. Location Code</span>
                                </div>
                                <div class="vx-col sm:w-2/3 w-full">
                                    <vx-input-group>
                                        <vs-input
                                            v-model="multimovementdata.dest_location_code"
                                            placeholder="Dest Location ID"
                                        />

                                        <template slot="append">
                                            <div class="append-text btn-addon">
                                                <vs-button
                                                    size="small"
                                                    color="primary"
                                                    type="border"
                                                    icon-pack="feather"
                                                    icon="icon-search"
                                                    @click="handlepopupmultidestinationlocation"
                                                ></vs-button>
                                            </div>
                                        </template>
                                    </vx-input-group>
                                </div>
                            </div>
                        </vs-row>
                        <vs-row class="flex justify-end">
                            <vs-button
                                @click="savemultimovementdraft"
                                class="mr-4"
                                color="primary"
                                type="filled"
                            >Next</vs-button>
                            <vs-button @click="showdraftpopup = false" type="flat">Cancel</vs-button>
                        </vs-row>
                    </vs-tab>
                </vs-tabs>
            </div>
        </vs-popup>

        <vs-popup title="Product" :active.sync="products.show" style="z-index: 99999">
            <vx-input-group>
                <vs-input v-model="products.search" placeholder="Product" />
                <template slot="append">
                    <div class="append-text btn-addon">
                        <vs-button
                            size="small"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-search"
                            @click="handleproductsearch"
                        ></vs-button>
                    </div>
                </template>
            </vx-input-group>
            <ag-grid-vue
                :gridOptions="products.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="products.columnDefs"
                :defaultColDef="products.defaultColDef"
                :rowData="products.rowdata"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @rowDoubleClicked="rowdoubleclickproduct"
                @selection-changed="onchangeselectionproduct"
            ></ag-grid-vue>
        </vs-popup>

        <vs-popup
            title="Source Location"
            :active.sync="singlesourcelocations.show"
            style="z-index: 99999"
        >
            <vx-input-group>
                <vs-input v-model="singlesourcelocations.search" placeholder="Source Location" />
                <template slot="append">
                    <div class="append-text btn-addon">
                        <vs-button
                            size="small"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-search"
                            @click="handlesinglesourcelocationsearch"
                        ></vs-button>
                    </div>
                </template>
            </vx-input-group>
            <ag-grid-vue
                :gridOptions="singlesourcelocations.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="singlesourcelocations.columnDefs"
                :defaultColDef="singlesourcelocations.defaultColDef"
                :rowData="singlesourcelocations.rowdata"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @rowDoubleClicked="rowdoubleclicksinglesourcelocation"
                @selection-changed="onchangeselectionsinglesourcelocation"
            ></ag-grid-vue>
        </vs-popup>

        <vs-popup title="Uoms" :active.sync="uoms.show" style="z-index: 99999">
            <vx-input-group>
                <vs-input v-model="uoms.search" placeholder="Source Location" />
                <template slot="append">
                    <div class="append-text btn-addon">
                        <vs-button
                            size="small"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-search"
                            @click="handleuomsearch"
                        ></vs-button>
                    </div>
                </template>
            </vx-input-group>
            <ag-grid-vue
                :gridOptions="uoms.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="uoms.columnDefs"
                :defaultColDef="uoms.defaultColDef"
                :rowData="uoms.rowdata"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @rowDoubleClicked="rowdoubleclickuom"
                @selection-changed="onchangeselectionuom"
            ></ag-grid-vue>
        </vs-popup>

        <vs-popup
            title="Destination Location"
            :active.sync="singledestinationlocations.show"
            style="z-index: 99999"
        >
            <vx-input-group>
                <vs-input
                    v-model="singledestinationlocations.search"
                    placeholder="Destination Location"
                />
                <template slot="append">
                    <div class="append-text btn-addon">
                        <vs-button
                            size="small"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-search"
                            @click="handlesingledestinationlocationsearch"
                        ></vs-button>
                    </div>
                </template>
            </vx-input-group>
            <ag-grid-vue
                :gridOptions="singledestinationlocations.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="singledestinationlocations.columnDefs"
                :defaultColDef="singledestinationlocations.defaultColDef"
                :rowData="singledestinationlocations.rowdata"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @rowDoubleClicked="rowdoubleclicksingledestinationlocation"
                @selection-changed="onchangeselectionsingledestinationlocation"
            ></ag-grid-vue>
        </vs-popup>

        <vs-popup
            title="Source Location"
            :active.sync="multisourcelocations.show"
            style="z-index: 99999"
        >
            <vx-input-group>
                <vs-input v-model="multisourcelocations.search" placeholder="Source Location" />
                <template slot="append">
                    <div class="append-text btn-addon">
                        <vs-button
                            size="small"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-search"
                            @click="handlemultisourcelocationsearch"
                        ></vs-button>
                    </div>
                </template>
            </vx-input-group>
            <ag-grid-vue
                :gridOptions="multisourcelocations.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="multisourcelocations.columnDefs"
                :defaultColDef="multisourcelocations.defaultColDef"
                :rowData="multisourcelocations.rowdata"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @rowDoubleClicked="rowdoubleclickmultisourcelocation"
                @selection-changed="onchangeselectionmultisourcelocation"
            ></ag-grid-vue>
        </vs-popup>

        <vs-popup
            title="Destination Location"
            :active.sync="multidestinationlocations.show"
            style="z-index: 99999"
        >
            <vx-input-group>
                <vs-input
                    v-model="multidestinationlocations.search"
                    placeholder="Destination Location"
                />
                <template slot="append">
                    <div class="append-text btn-addon">
                        <vs-button
                            size="small"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-search"
                            @click="handlemultidestinationlocationsearch"
                        ></vs-button>
                    </div>
                </template>
            </vx-input-group>
            <ag-grid-vue
                :gridOptions="multidestinationlocations.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="multidestinationlocations.columnDefs"
                :defaultColDef="multidestinationlocations.defaultColDef"
                :rowData="multidestinationlocations.rowdata"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @rowDoubleClicked="rowdoubleclickmultidestinationlocation"
                @selection-changed="onchangeselectionmultidestinationlocation"
            ></ag-grid-vue>
        </vs-popup>
    </div> -->
</template>

<script>
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr
    },
    data() {
        return {
            selected: [],
            isLoading: false,
            movementorder: {
                client_id: null,
                reference: '',
                auto_confirm: false,
                warehouse_id: null,
                movement_date: new Date()
            },
            draftmovementorder: {
                gridoptions: {},
                columnDefs: [],
                rowdata: [],
                select: {}
            },
            products: {
                show: false,
                gridoptions: {},
                columnDefs: [],
                rowdata: [],
                search: "",
                select: {}
            },
            singlesourcelocations: {
                show: false,
                gridoptions: {},
                columnDefs: [],
                rowdata: [],
                search: "",
                select: {}
            },
            multisourcelocations: {
                show: false,
                gridoptions: {},
                columnDefs: [],
                rowdata: [],
                search: "",
                select: {}
            },
            singledestinationlocations: {
                show: false,
                gridoptions: {},
                columnDefs: [],
                rowdata: [],
                search: "",
                select: {}
            },
            multidestinationlocations: {
                show: false,
                gridoptions: {},
                columnDefs: [],
                rowdata: [],
                search: "",
                select: {}
            },
            uoms: {
                show: false,
                gridoptions: {},
                columnDefs: [],
                rowdata: [],
                search: "",
                select: {}
            },
            // Show Pop UP
            showdraftpopup: false,
            clients: [],
            warehouses: [],
            singlemovementdata: {},
            multimovementdata: {},
            client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            warehouse: {
                data: [],
                loading: false,
                endpoint: 'master/warehouses',
                objectKey: 'warehouses_code'
            },
            stock_type: {
                data: [],
                loading: false,
                endpoint: 'master/stocktypes',
                objectKey: 'name'
            },
            product: []
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        back() {
            this.$router.go(-1);
        },
        // Logic
        conversion(data) {
            if (data.qty > 0) {
                data.base_qty = (data.qty / data.denominator) * data.numerator;
                data.err = false;
                data.errText = "";
            } else {
                data.base_qty = 0;
                data.err = true;
                data.errText = "qty must be higer than 0";
            }

            return data;
        },
        // handle PopUp Show
        handleShowAddForm() {
            this.$vs.loading()
            Promise.all([
                this.$http.post('master/product/showbyclient', { client_id: this.movementorder.client_id }),
                this.$http.post("master/stocktypes")
            ])
            .then(this.$http.spread((product, stocktypes) => {
                this.product = product.data.data
                this.stock_type.data = stocktypes.data.data
                this.showdraftpopup = true;
                this.$vs.loading.close()
            }))
            .catch(error => this.handleError(error))
        },
        handlepopupproduct() {
            this.products.show = true;
            this.products.gridoptions.api.sizeColumnsToFit();
            this.getProductData();
        },
        handlepopupsinglesourcelocation() {
            this.singlesourcelocations.show = true;
            this.getSingleSourceLocationData();
        },
        handlepopupsingledestinationlocation() {
            this.singledestinationlocations.show = true;
            this.getSingleDestinationLocationData();
        },
        handlepopupuom() {
            this.uoms.show = true;
            this.getUomData();
            this.uoms.gridoptions.api.sizeColumnsToFit();
        },
        handlepopupmultisourcelocation() {
            this.multisourcelocations.show = true;
            this.getMultiSourceLocationData();
        },
        handlepopupmultidestinationlocation() {
            this.multidestinationlocations.show = true;
            this.getMultiDestinationLocationData();
        },
        // handle Delete Draft Movement Order
        handleDeleteForm() {
            let indexes = []
            this.selected.map(item => {
                this.draftmovementorder.rowdata.map((detail, index) => {
                    if(detail.line_id == item.line_id) {
                        indexes.push(index)
                    }
                })
            })

            indexes.sort((a, b) => b - a)

            this.selected = []

            indexes.map(index => {
                this.draftmovementorder.rowdata.splice(index, 1)
            })
            this.assignLineId()
            // this.isLoading = true;
            // const selectData = this.draftmovementorder.gridoptions.api.getSelectedRows();
            // if (selectData.length <= 0) {
            //     this.$vs.notify({
            //         color: "danger",
            //         title: "Error",
            //         iconPack: "feather",
            //         icon: "icon-x",
            //         text: "No data selected"
            //     });
            // } else {
            //     let drafts = [];
            //     selectData.forEach(data => {
            //         drafts.push(data.draft_id);
            //     });
            //     Promise.all([
            //         this.$http.post(
            //             "inventories/movementorder/draftmo/destroy",
            //             {
            //                 draft_mo: JSON.stringify(drafts)
            //             }
            //         )
            //     ])
            //         .then(
            //             this.$http.spread(resp => {
            //                 this.isLoading = false;
            //                 this.$vs.notify({
            //                     color: "success",
            //                     title: "Movement Order Deleted!",
            //                     iconPack: "feather",
            //                     icon: "icon-check",
            //                     text: "Deleted Movement Order Successfully!"
            //                 });
            //                 this.draftmovementorder.rowdata = this.draftmovementorder.rowdata.filter(
            //                     item => drafts.indexOf(item.draft_id) === -1
            //                 );
            //             })
            //         )
            //         .catch(err => {
            //             this.isLoading = false;
            //             this.$vs.notify({
            //                 color: "danger",
            //                 title: "Delete Movement Order Failed",
            //                 iconPack: "feather",
            //                 icon: "icon-check",
            //                 text: err.response.data.message
            //             });
            //         });
            // }
        },
        assignLineId() {
            this.draftmovementorder.rowdata.map((detail, index) => detail.line_id = index + 1)
        },
        // Handle Save
        savemovementorder() {
            this.isLoading = true;
            let drafts = [];
            this.draftmovementorder.rowdata.forEach(data => {
                drafts.push(data.draft_id);
            });

            this.$http.post("inventories/movementorder/singleitem", {
                mo_header: JSON.stringify({
                    reference: this.movementorder.reference || null,
                    movement_date: this.movementorder.movement_date || null,
                    client_id: this.movementorder.client_id,
                    warehouse_id: this.movementorder.warehouse_id,
                    auto_confirm: this.movementorder.auto_confirm || 0
                }),
                draft_mo: JSON.stringify(drafts)
            }).then(movementorder => {
                this.isLoading = false;
                this.$vs.notify({
                    color: "success",
                    title: "Movement Order Success",
                    iconPack: "feather",
                    icon: "icon-check",
                    text: "Sucess Saving!"
                });
                this.$router.push({ name: "movement-order" });
            })
            .catch(err => this.handleError(err))
            .then(() => (this.isLoading = false));
        },
        savesinglemovementdraft() {
            this.isLoading = true;
            Promise.all([
                this.$http.post(
                    "inventories/movementorder/draftmo/singlestore",
                    {
                        inventories_id: this.singlesourcelocations.select.id,
                        qty: this.singlemovementdata.available_qty,
                        uom_id: this.singlemovementdata.uom_id,
                        stock_type_id: this.singlemovementdata.stock_type_id,
                        dest_location_id: this.singledestinationlocations.select
                            .location_id,
                        dest_storage_unit:
                            this.singlemovementdata.dest_storage_unit || null
                    }
                )
            ])
                .then(
                    this.$http.spread(draft_mo => {
                        this.singlemovementdata = {};
                        let tmpdata = draft_mo.data.draft_mo;
                        tmpdata.line_id =
                            this.draftmovementorder.rowdata.length <= 0
                                ? 1
                                : this.draftmovementorder.rowdata[
                                      this.draftmovementorder.rowdata.length - 1
                                  ].line_id + 1;
                        this.draftmovementorder.rowdata.push(tmpdata);
                        this.showdraftpopup = false;
                    })
                )
                .catch(err => {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error saving!",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: err.response.data.message
                    });
                })
                .then(() => (this.isLoading = false));
        },
        savemultimovementdraft() {
            this.isLoading = true;
            this.$http.post("inventories/movementorder/draftmo/multistore",
                {
                    location_id: this.multisourcelocations.select.location_id,
                    location_destination_id: this.multidestinationlocations
                        .select.location_id
            })
            .then(draft_mo => {
                this.showdraftpopup = false;
                this.showAdd = false;
                this.isLoading = false
                this.multimovementdata = {};
                draft_mo.data.draft_mo.forEach(datamo => {
                    let tmpdata = datamo;
                    tmpdata.line_id = this.draftmovementorder.rowdata.length <= 0 ? 1 : this.draftmovementorder.rowdata.length + 1;
                    this.draftmovementorder.rowdata.push(tmpdata);
                })
            })
            .catch(err => this.handleError(err))
        },
        // Get From API
        getClientData() {
            this.isLoading = true;
            this.clients = [];
            Promise.all([this.$http.post("master/clients/filter/dropdown")])
                .then(
                    this.$http.spread(clients => {
                        this.clients = clients.data;
                    })
                )
                .catch(err => {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error saving!",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: err.response.data.message
                    });
                })
                .then(() => (this.isLoading = false));
        },
        getWarehouseData() {
            this.isLoading = true;
            this.warehouses = [];
            Promise.all([this.$http.post("master/warehouses/filter/dropdown")])
                .then(
                    this.$http.spread(warehouses => {
                        this.warehouses = warehouses.data;
                    })
                )
                .catch(err => {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error saving!",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: err.response.data.message
                    });
                })
                .then(() => (this.isLoading = false));
        },
        getProductData() {
            this.isLoading = true;
            this.products.rowdata = [];
            Promise.all([
                this.$http.post("inventories/movementorder/getproduct", {
                    client_id: this.movementorder.client.id,
                    warehouse_id: this.movementorder.warehouse.id,
                    product_code: this.products.search
                })
            ])
                .then(
                    this.$http.spread(products => {
                        this.products.rowdata = products.data.data;
                    })
                )
                .catch(err => {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error saving!",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: err.response.data.message
                    });
                })
                .then(() => (this.isLoading = false));
        },
        getSingleSourceLocationData() {
            this.$vs.loading();
            this.singlesourcelocations.rowdata = [];
            this.$vs.loading();
            this.$http.post("inventories/movementorder/sourcelocation", {
                client_id: this.movementorder.client_id,
                warehouse_id: this.movementorder.warehouse_id,
                product_id: this.singlemovementdata.product_id,
                pack_id: this.singlemovementdata.pack_id,
                exp_date: this.singlemovementdata.exp_date,
                batch: this.singlemovementdata.batch,
                storage_unit: this.singlemovementdata.source_storage_unit,
                location_code: this.singlesourcelocations.search
            })
            .then(sourceLocation => {
                this.singlesourcelocations.show = true;
                this.singlesourcelocations.rowdata = sourceLocation.data.source_location
                this.$vs.loading.close();
            })
            .catch(err => this.handleError(err))
        },
        getUomData() {
            this.isLoading = true;
            Promise.all([
                this.$http.post("inventories/movementorder/getproduct/uoms", {
                    product_code: this.singlemovementdata.product_code,
                    product_id: this.products.select.product_id,
                    // name: this.singlemovementdata.available_uom,
                    uom_name: this.uoms.search
                })
            ])
                .then(
                    this.$http.spread(uoms => {
                        this.uoms.rowdata = uoms.data;
                    })
                )
                .catch(err => {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error saving!",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: err.response.data.message
                    });
                })
                .then(() => (this.isLoading = false));
        },
        getMultiSourceLocationData() {
            this.isLoading = true;
            this.multisourcelocations.rowdata = [];
            Promise.all([
                this.$http.post("inventories/movementorder/sourcelocation", {
                    location_code: this.multisourcelocations.search
                })
            ])
                .then(
                    this.$http.spread(sourceLocation => {
                        this.multisourcelocations.rowdata =
                            sourceLocation.data.source_location;
                    })
                )
                .catch(err => {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error saving!",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: err.response.data.message
                    });
                })
                .then(() => (this.isLoading = false));
        },
        getSingleDestinationLocationData() {
            this.singledestinationlocations.rowdata = [];
            this.isLoading = true;
            Promise.all([
                this.$http.post(
                    "http://api-wms.gabi.id/inventories/movementorder/locationavailable",
                    {
                        location_code: this.singledestinationlocations.search
                    }
                )
            ])
                .then(
                    this.$http.spread(destinationlocations => {
                        this.singledestinationlocations.rowdata =
                            destinationlocations.data.data;
                    })
                )
                .catch(err => {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error saving!",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: err.response.data.message
                    });
                })
                .then(() => (this.isLoading = false));
        },
        getMultiDestinationLocationData() {
            this.multidestinationlocations.rowdata = [];
            this.isLoading = true;
            Promise.all([
                this.$http.post(
                    "http://api-wms.gabi.id/inventories/movementorder/locationavailable",
                    {
                        location_code: this.multidestinationlocations.search
                    }
                )
            ])
                .then(
                    this.$http.spread(destinationlocations => {
                        this.multidestinationlocations.rowdata =
                            destinationlocations.data.data;
                    })
                )
                .catch(err => {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error saving!",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: err.response.data.message
                    });
                })
                .then(() => (this.isLoading = false));
        },
        // handle search
        handleproductsearch() {
            this.getProductData();
        },
        handlesinglesourcelocationsearch() {
            this.getSingleSourceLocationData();
        },
        handlesingledestinationlocationsearch() {
            this.getSingleDestinationLocationData();
        },
        handleuomsearch() {
            this.getUomData();
        },
        handlemultisourcelocationsearch() {
            this.getMultiSourceLocationData();
        },
        handlemultidestinationlocationsearch() {
            this.getMultiDestinationLocationData();
        },
        // Handle Double Click
        rowdoubleclickproduct() {
            this.products.show = false;
            this.singlemovementdata.product_code = this.products.select.product_code;
            this.singlemovementdata.description = this.products.select.description_1;
        },
        rowdoubleclicksinglesourcelocation() {
            this.singlesourcelocations.show = false;
            this.singlemovementdata.source_location_code = this.singlesourcelocations.select.location_code;

            this.singlemovementdata.available_qty = this.singlesourcelocations.select.available_qty;
            this.singlemovementdata.available_uom = this.singlesourcelocations.select.base_uom_name;
            this.singlemovementdata.base_qty = this.singlesourcelocations.select.base_qty;
            this.singlemovementdata.base_uom = this.singlesourcelocations.select.base_uom_name;
            this.singlemovementdata.uom_id = this.singlesourcelocations.select.base_uom_id;
            this.singlemovementdata.stock_type = this.singlesourcelocations.select.stock_type_code;
            this.singlemovementdata.stock_type_id = this.singlesourcelocations.select.stock_type_id;
        },
        rowdoubleclickmultisourcelocation() {
            this.multisourcelocations.show = false;
            this.multimovementdata.source_location_code = this.multisourcelocations.select.location_code;
        },
        rowdoubleclickuom() {
            this.uoms.show = false;
            this.singlemovementdata.available_uom = this.uoms.select.uom.name;
            let tmpConversion = {};
            tmpConversion.base_qty = this.singlemovementdata.base_qty;
            tmpConversion.qty = this.singlemovementdata.available_qty;
            tmpConversion.denominator = this.uoms.select.denominator;
            tmpConversion.numerator = this.uoms.select.numerator;
            this.singlemovementdata.base_qty = this.conversion(
                tmpConversion
            ).base_qty;
        },
        rowdoubleclicksingledestinationlocation() {
            this.singledestinationlocations.show = false;
            this.singlemovementdata.dest_location_code = this.singledestinationlocations.select.location_code;
        },
        rowdoubleclickmultidestinationlocation() {
            this.multidestinationlocations.show = false;
            this.multimovementdata.dest_location_code = this.multidestinationlocations.select.location_code;
        },
        // Handle On Change
        onchangeselectionproduct() {
            let selectedRows = this.products.gridoptions.api.getSelectedRows();
            this.products.select = selectedRows[0];
        },
        onchangeselectionsinglesourcelocation() {
            let selectedRows = this.singlesourcelocations.gridoptions.api.getSelectedRows();
            this.singlesourcelocations.select = selectedRows[0];
        },
        onchangeselectionuom() {
            let selectedRows = this.uoms.gridoptions.api.getSelectedRows();
            this.uoms.select = selectedRows[0];
        },
        onchangeselectionsingledestinationlocation() {
            let selectedRows = this.singledestinationlocations.gridoptions.api.getSelectedRows();
            this.singledestinationlocations.select = selectedRows[0];
        },
        onchangeselectionmultisourcelocation() {
            let selectedRows = this.multisourcelocations.gridoptions.api.getSelectedRows();
            this.multisourcelocations.select = selectedRows[0];
        },
        onchangeselectionmultidestinationlocation() {
            let selectedRows = this.multidestinationlocations.gridoptions.api.getSelectedRows();
            this.multidestinationlocations.select = selectedRows[0];
        },
        fetchDropdown() {
            Promise.all([
                this.$http.post("master/clients"),
                this.$http.post("master/warehouses"),
            ])
            .then(this.$http.spread((client, warehouse) => {
                this.client.data = client.data.data
                this.warehouse.data = warehouse.data.data
                this.$vs.loading.close();
            }))
            .catch(error => {
                this.isLoading = false
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Server Error',
                    text: 'Try again?',
                    accept: () => {
                        this.fetchDropdown()
                    },
                    cancel: () => this.$router.push({name: 'movement-order'}),
                    acceptText: 'Yes',
                    cancelText: 'No'
                })
            })
        }
    },
    computed: {},
    mounted() {
        this.fetchDropdown();
        this.$vs.loading();
        // this.movementorder.client.id = this.$store.state.user.userconfig.clients.id;
        // this.movementorder.client.client_code = this.$store.state.user.userconfig.clients.client_code;
        // this.movementorder.warehouse.id = this.$store.state.user.userconfig.warehouses.id;
        // this.movementorder.warehouse.name = this.$store.state.user.userconfig.warehouses.name;
    },
    beforeMount() {
        this.draftmovementorder.columnDefs = [
            {
                headerName: "Line ID",
                field: "line_id",
                width: 120,
                checkboxSelection: true,
                // headerCheckboxSelectionFilteredOnly: true,
                headerCheckboxSelection: true
            },
            {
                headerName: "Product Code",
                field: "product_code",
                width: 100
            },
            {
                headerName: "Description",
                field: "description_1",
                width: 100
            },
            {
                headerName: "Pack ID",
                field: "pack_id",
                width: 100
            },
            {
                headerName: "Batch",
                field: "batch",
                width: 100
            },
            {
                headerName: "Exp. Date",
                field: "expired_date",
                width: 100
            },
            {
                headerName: "Base Qty",
                field: "base_qty",
                width: 100
            },
            {
                headerName: "Base UoM",
                field: "base_uom_name",
                width: 100
            },
            {
                headerName: "Stock Type",
                field: "stock_type_name",
                width: 100
            },
            {
                headerName: "Source Location Type",
                field: "location_type_code",
                width: 100
            },
            {
                headerName: "Source Location Code",
                field: "location_code",
                width: 100
            },
            {
                headerName: "Source Storage Unit",
                field: "storage_unit",
                width: 100
            },
            {
                headerName: "Dest. Location Type",
                field: "destination_location_type",
                width: 100
            },
            {
                headerName: "Dest. Location Code",
                field: "destination_location",
                width: 100
            },
            {
                headerName: "Dest. Storage Unit",
                field: "destination_storage_unit",
                width: 100
            }
        ];
        this.products.columnDefs = [
            {
                headerName: "Product ID",
                field: "product_id",
                width: 100,
                hide: true
            },
            {
                headerName: "Product Code",
                field: "product_code",
                width: 100
            },
            {
                headerName: "Client ID",
                field: "client_id",
                width: 100
            },
            {
                headerName: "Description",
                field: "description_1",
                width: 100
            },
            {
                headerName: "Base UOM",
                field: "base_uom_name",
                width: 100
            }
        ];
        this.uoms.columnDefs = [
            {
                headerName: "UoM",
                field: "uom.name",
                width: 100
            },
            {
                headerName: "Description",
                field: "uom.description",
                width: 100
            }
        ];
        this.singlesourcelocations.columnDefs = [
            {
                headerName: "Warehouse Code",
                field: "warehouses_code",
                width: 100
            },
            {
                headerName: "Location Code",
                field: "location_code",
                width: 100
            },
            {
                headerName: "Type",
                field: "code",
                width: 100
            },
            {
                headerName: "Batch",
                field: "batch",
                width: 100
            },
            {
                headerName: "Pack ID",
                field: "pack_id",
                width: 100
            },
            {
                headerName: "Exp. Date",
                field: "exp_date",
                width: 100
            },
            {
                headerName: "Stock Type",
                field: "stock_type_code",
                width: 100
            },
            {
                headerName: "Avaiable QTY",
                field: "available_qty",
                width: 100
            },
            {
                headerName: "Base UoM",
                field: "base_uom_name",
                width: 100
            },
            {
                headerName: "Base Qty",
                field: "base_qty",
                width: 100
            },
            {
                headerName: "Allocated Qty",
                field: "allocated_qty",
                width: 100
            },
            {
                headerName: "Storage Unit",
                field: "storage_unit",
                width: 100
            },
            {
                headerName: "Pick Block",
                field: "pick_block",
                width: 100
            }
        ];
        this.multisourcelocations.columnDefs = [
            {
                headerName: "Warehouse Code",
                field: "warehouses_code",
                width: 100
            },
            {
                headerName: "Location Code",
                field: "location_code",
                width: 100
            },
            {
                headerName: "Type",
                field: "code",
                width: 100
            },
            {
                headerName: "Batch",
                field: "batch",
                width: 100
            },
            {
                headerName: "Pack ID",
                field: "pack_id",
                width: 100
            },
            {
                headerName: "Exp. Date",
                field: "exp_date",
                width: 100
            },
            {
                headerName: "Stock Type",
                field: "stock_type_code",
                width: 100
            },
            {
                headerName: "Avaiable QTY",
                field: "available_qty",
                width: 100
            },
            {
                headerName: "Base UoM",
                field: "base_uom_name",
                width: 100
            },
            {
                headerName: "Base Qty",
                field: "base_qty",
                width: 100
            },
            {
                headerName: "Allocated Qty",
                field: "allocated_qty",
                width: 100
            },
            {
                headerName: "Storage Unit",
                field: "storage_unit",
                width: 100
            },
            {
                headerName: "Pick Block",
                field: "pick_block",
                width: 100
            }
        ];
        this.singledestinationlocations.columnDefs = [
            {
                headerName: "Warehouse Code",
                field: "warehouses_code",
                width: 100
            },
            {
                headerName: "Location Code",
                field: "location_code",
                width: 100
            },
            {
                headerName: "Type",
                field: "location_type_code",
                width: 100
            },
            {
                headerName: "Client Code",
                field: "client_code",
                width: 100
            },
            {
                headerName: "Section",
                field: "section_code",
                width: 100
            }
        ];
        this.multidestinationlocations.columnDefs = [
            {
                headerName: "Warehouse Code",
                field: "warehouses_code",
                width: 100
            },
            {
                headerName: "Location Code",
                field: "location_code",
                width: 100
            },
            {
                headerName: "Type",
                field: "location_type_code",
                width: 100
            },
            {
                headerName: "Client Code",
                field: "client_code",
                width: 100
            },
            {
                headerName: "Section",
                field: "section_code",
                width: 100
            }
        ];
    }
};
</script>